import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../Buttons/SbActionDropdownButton';
import SbCancelBtn, { SbAddBtn, SbFilterBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
import calendar from '../../assets/images/Dashboard/calendar-icon.svg';
import { Col, Dropdown, Form, Modal, ProgressBar, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg'
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import AddSLA from './AddSLA';
import ViewAssignedToSla from './ViewAssignedToSla';
import PaginationComponent from '../PaginationComponent';
import { useDispatch, useSelector } from 'react-redux';
import { loadAssignedToSlaData, loadModuleFieldNames, loadSingleAssignedToSlaData } from '../../redux/action';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import noDataFound from '../../assets/images/no-data-found.svg';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import AssignedToSlaColumnFilterModal from './AssignedToSlaColumnFilterModal';
import SlaAssignToValueFilterModal from './SlaAssignToValueFilterModal';
import UpdateSlaModal from './UpdateSlaModal';
import { useLocation, useParams } from 'react-router-dom';
import noModuleAccess from '../../assets/images/no-module-access.svg';
import { formatDate } from '../DateTimeUtils';
import { Highlighter, Typeahead } from 'react-bootstrap-typeahead';

const columns = [
    { id: 'SLAID', label: 'SLA NO', align: 'left', minWidth: '100px' },
    { id: 'SLAType', label: 'TYPE', align: 'left', minWidth: '120px' },
    { id: 'CustomerName', label: 'COMPANY NAME', align: 'left', minWidth: '180px' },
    { id: 'SLACategoryName', label: 'SLA CATEGORIES', align: 'left', minWidth: '200px' },
    { id: 'Remarks', label: 'DESCRIPTION', align: 'left', minWidth: '150px' },
    { id: 'ValueType', label: 'VALUE TYPE', align: 'left', minWidth: '150px' },
    { id: 'BaseLine', label: 'BASELINE', align: 'left', minWidth: '150px' },
    { id: 'TargetPercentage', label: 'TARGET', align: 'left', minWidth: '120px' },
    { id: 'TargetValue', label: 'TARGET VALUE', align: 'left', minWidth: '150px' },
    { id: 'AchievedPercentage', label: 'ACHIEVED', align: 'left', minWidth: '150px' },
    { id: 'StartDate/EndDate', label: 'START DATE / END DATE', align: 'left', minWidth: '280px' },
    // { id: 'AssignedTo', label: 'ASSIGNED TO', align: 'left', minWidth: '200px' },
    { id: 'AssignToUser', label: 'ASSIGNED TO USER', align: 'left', minWidth: '250px' },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const SortableHead = SortableContainer(({ children }) => {
    return (
        <TableHead>
            <TableRow>{children}</TableRow>
        </TableHead>
    );
});

const SortableCell = SortableElement(({ value }) => {
    return <TableCell>{value}</TableCell>;
});

const AssignToTable = ({ assignedToSlaData, loading, assignedToSlaDatas, searchText, setSearchText, setSearchQuery, setSearchParams }) => {
    let dispatch = useDispatch();
    let location = useLocation();
    const { id: slaRefId } = useParams();

    const getStoredColumnsOrder = () => {
        const savedOrder = localStorage.getItem('assignedToSlaColumnsOrder');
        return savedOrder ? JSON.parse(savedOrder) : columns.map((col) => col.id);
    };

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const DateFormat = signInDetails[0]?.DateFormat;
    const CompanyID = signInDetails[0]?.CompanyID;
    const SignInType = signInDetails[0]?.SignInType;
    const PreviousSuperAdminSignInType = sessionStorage.getItem('PreviousSuperAdminSignInType');

    // const { assignedToSlaData = [] } = useSelector((state) => state.data);
    const { singleAssignedToSlaData } = useSelector((state) => state.data);
    const { getModuleFieldsNames } = useSelector((state) => state.data);
    // const { modulePermissions } = useSelector((state) => state.data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];
    const [moduleData, setModuleData] = useState(null);
    const [selected, setSelected] = useState([]);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    // useEffect(() => {
    //     if (moduleId && storedModulePermissions.length) {
    //         // Find the module data using the moduleId
    //         const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
    //         setModuleData(module);
    //     }
    // }, [storedModulePermissions, moduleId]);

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Loop through storedModulePermissions and nested MainModules and SubModules to find the matching ModuleID
            let foundModule = null;

            outerLoop:
            for (const sidebarMenu of storedModulePermissions) {
                for (const mainModule of sidebarMenu.MainModules) {
                    if (mainModule.SubModules && mainModule.SubModules.length > 0) {
                        const subModule = mainModule.SubModules.find(sub => sub.ModuleID === moduleId);
                        if (subModule) {
                            foundModule = subModule;
                            break outerLoop;
                        }
                    }
                }
            }

            setModuleData(foundModule);
        }
    }, [storedModulePermissions, moduleId]);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedColumns, setSelectedColumns] = useState([
        "SLA NO", "TYPE", "COMPANY NAME", "SLA CATEGORIES", "DESCRIPTION", "VALUE TYPE", "BASELINE", "TARGET", "TARGET VALUE", "ACHIEVED", "START DATE / END DATE", "ASSIGNED TO USER", "ACTION"
    ]);
    const [columnsOrder, setColumnsOrder] = useState(getStoredColumnsOrder());

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (slaRefId) {
            dispatch(loadSingleAssignedToSlaData(slaRefId));
        } else {
            assignedToSlaDatas();
        }
    }, [slaRefId]);

    // Get selected columns (based on `selectedColumns` prop)
    const filteredColumns = columns.filter((column) =>
        selectedColumns.includes(column.label)
    );

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    // const assignedToSlaDatas = () => {
    //     dispatch(loadAssignedToSlaData(setLoading));
    // }
    // useEffect(() => {
    //     assignedToSlaDatas();
    // }, []);

    const onReorderEnd = ({ oldIndex, newIndex }) => {
        const newOrder = Array.from(columnsOrder);
        const [moved] = newOrder.splice(oldIndex, 1);
        newOrder.splice(newIndex, 0, moved);
        setColumnsOrder(newOrder);
        localStorage.setItem('assignedToSlaColumnsOrder', JSON.stringify(newOrder)); // Store new order
    };

    const filteredData = slaRefId ? (singleAssignedToSlaData ? singleAssignedToSlaData : []) : assignedToSlaData;

    const sortedData = React.useMemo(() => {
        const stabilizedData = filteredData?.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [filteredData, order, orderBy]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [viewSlaAssignToModal, setViewSlaAssignToModal] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [clickedCell, setClickedCell] = useState({ rowId: null, columnId: null }); // Track clicked cell
    const [files, setFiles] = useState([]);
    const [showAttachmentUploadModal, setShowAttachmentUploadModal] = useState(false);
    const [progress, setProgress] = useState([]);
    const [droppedFile, setDroppedFile] = useState(null);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [slaId, setSlaId] = useState("");

    const fileInputRef = useRef(null);

    const renderCellValue = (customer, column) => {
        const value = customer[column.id];
        const valueType = customer.ValueType;

        // Fields that can vary based on ValueType
        const conditionalFields = ["BaseLine", "TargetValue", "TargetPercentage"];
        if (conditionalFields.includes(column.id)) {
            if (valueType === "Date" && value) {
                return formatDate(value);
            } else if (valueType === "Percentage" && value !== null && value !== undefined) {
                return `${value}%`;
            } else if (typeof value === "number") {
                return value.toLocaleString(); // optional number formatting
            }
            return value ?? "-";
        }

        // Special field to show StartDate / EndDate
        if (column.id === "StartDate/EndDate") {
            return `${formatDate(customer.StartDate)} / ${formatDate(customer.EndDate)}`;
        }

        // General formatting for StartDate and EndDate
        const alwaysDateFields = ["StartDate", "EndDate"];
        if (alwaysDateFields.includes(column.id)) {
            return formatDate(value);
        }

        return value ?? "-";
    };

    useEffect(() => {
        if (fromDate && toDate) {
            // Format the dates using moment.js
            const formattedFromDate = moment(fromDate).format('DD-MMM-YYYY'); // e.g., 01-Jan-2025
            const formattedToDate = moment(toDate).format('DD-MMM-YYYY');     // e.g., 15-Jan-2025

            // Build the WHERE clause with formatted dates
            const whereClause = `CONVERT(DATE,SA.SLA_StartDate,101) >= CONVERT(DATE,'${formattedFromDate}',101) AND CONVERT(DATE,SA.SLA_EndDate,101) <= CONVERT(DATE,'${formattedToDate}',101)`;

            // Update the searchParams state with the final WHERE clause
            setSearchParams(whereClause);
        } else {
            // Clear date filter if no dates are selected
            setSearchParams('');
        }
    }, [fromDate, toDate]); // The dependencies include fromDate, toDate, and searchText

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (slaID) => {
        setIsModalOpen(true);
        // setIsModalOpen(true);
        dispatch(loadModuleFieldNames(null, 6, null));
        if (slaID) {
            dispatch(loadSingleAssignedToSlaData(slaID));
            setSlaId(slaID);
        } else {
            setSlaId("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenAssignToModal = (slaID) => {
        setViewSlaAssignToModal(true);
        if (slaID) {
            dispatch(loadSingleAssignedToSlaData(slaID));
            setSlaId(slaID);
        } else {
            setSlaId("");
        }
    };

    const handleCloseAssignToModal = () => {
        setViewSlaAssignToModal(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    // Pagination logic
    useEffect(() => {
        const start = page * rowsPerPage; // Updated page logic to 0-based
        const end = start + rowsPerPage;
        setPaginatedData(sortedData.slice(start, end));
    }, [sortedData, page, rowsPerPage]);

    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    const handleOpenAttachmentUploadModal = () => {
        // Reset the state before opening the modal
        setDroppedFile(null);
        setFiles([]);
        setProgress([]);
        setUploadComplete(false);
        setShowAttachmentUploadModal(true);
    };

    const handleCloseBulkUploadModal = () => {
        setShowAttachmentUploadModal(false);
        // Reset states when closing the modal if needed
        setDroppedFile(null);
        setFiles([]);
        setProgress([]);
        setUploadComplete(false);
    };

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        processFiles(newFiles);
    };

    const validFileTypes = ['image/jpeg', 'image/png', 'image/jpg']; // Allowed file types
    const maxFiles = 5; // Maximum number of files

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const newFiles = Array.from(event.dataTransfer.files);
        console.log('Dropped files:', newFiles);

        // Check for duplicates and validate file types
        const existingFiles = new Set(files.map(file => file.name));
        const uniqueFiles = newFiles.filter(file => {
            const isValidType = validFileTypes.includes(file.type);
            const isDuplicate = existingFiles.has(file.name);
            return isValidType && !isDuplicate;
        });

        console.log('Unique files to be added:', uniqueFiles);

        // Check if adding these files exceeds the limit
        if (files.length + uniqueFiles.length > maxFiles) {
            alert(`You can only upload a maximum of ${maxFiles} files.`);
            return;
        }

        if (uniqueFiles.length > 0) {
            processFiles(uniqueFiles);
        }
    };

    const processFiles = (newFiles) => {
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        setProgress((prevProgress) => [
            ...prevProgress,
            ...newFiles.map(() => 0)
        ]);
        simulateProgress(newFiles.length);
    };

    const simulateProgress = (newFileCount) => {
        const currentFileIndex = files.length;
        for (let i = 0; i < newFileCount; i++) {
            let progressValue = 0;
            const interval = setInterval(() => {
                if (progressValue >= 100) {
                    clearInterval(interval);
                    setUploadComplete(true); // Set completion status
                    return;
                }
                progressValue += 10;
                setProgress((prevProgress) => {
                    const newProgress = [...prevProgress];
                    newProgress[currentFileIndex + i] = progressValue;
                    return newProgress;
                });
            }, 500);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation(); // Stop the event from bubbling up
    };

    const removeFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        setProgress((prevProgress) => prevProgress.filter((_, i) => i !== index));
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    // Handle the search input change (when selecting an item from Typeahead)
    const handleSearchChange = (selected) => {
        const query = selected.length ? selected[0] : ''; // Get the selected query or an empty string
        const selectedSlaId = query.SLAID;
        setSearchQuery(selectedSlaId); // Update searchQuery
        setSearchText(query); // Update searchText
        setSelected(selected);
    };

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        setFromDate(null);
        setToDate(null);
        assignedToSlaDatas();
        setSelected([]);
    }

    const processedAssinedToData = useMemo(() => {
        return assignedToSlaData.map(item => {
            const assignToNames = Array.isArray(item.AssignToUser)
                ? [...new Set(item.AssignToUser.map(u => u.UserName))].join(', ')
                : '';

            return {
                ...item,
                SLAID: String(item.SLAID || 'N/A'),
                SLAType: String(item.SLAType || ''),
                SLACategoryName: String(item.SLACategoryName || ''),
                CustomerName: String(item.CustomerName || ''),
                AssignToUser: assignToNames, // 💡 New field for display and search
            };
        });
    }, [assignedToSlaData]);

    return (
        <>
            <Row className='customermanagement-btns-container'>
                <Col md={2} className='customermanagement-backbtn-div'>
                    <span>Service Level Agreement</span>
                </Col>
                <Col md={10} className='customermanagement-search-filter'>
                    <div className='customermanagement-header-btns filter-btn'>
                        <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                        {showFilterMenu && (
                            <Dropdown.Menu show className='filter-dropdown-options'>
                                <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                    <img src={columnFilter} alt="Column Filter" />&nbsp;&nbsp;
                                    Column Filter
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                    <img src={valueFilter} alt="Value Filter" />&nbsp;&nbsp;
                                    Value Filter
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        )}
                    </div>
                    <Col md={3} className='filters-col'>
                        <div className='customermanagement-search'>
                            {/* <Form.Control
                                type="search"
                                placeholder='Search'
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            /> */}
                            <Typeahead
                                id="search-typeahead"
                                className='typeahead-search'
                                onChange={handleSearchChange}
                                options={processedAssinedToData}
                                labelKey="SLAType" // We are using a string (the company name), so we just use the string directly
                                filterBy={['SLAID', 'SLAType', 'SLACategoryName', 'CustomerName', 'AssignToUser']}
                                placeholder="Search SLA"
                                selected={selected}
                                value={searchText}
                                onInputChange={(input) => setSearchText(input)} // Update searchText with typed value
                                minLength={1} // Minimum characters before suggestions appear
                                autoFocus={false} // Prevent auto focusing on input
                                renderMenu={(results, menuProps) => {
                                    // ✅ Hide table if an item is selected
                                    if (selected.length > 0 || !results.length) {
                                        return null;
                                    }

                                    return (
                                        <div {...menuProps} className='typeahead-search-options-table'>
                                            <table className="table table-sm  mb-0">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th style={{ 'minWidth': '100px' }}>Sla Id</th>
                                                        <th style={{ 'minWidth': '120px' }}>Sla Type</th>
                                                        <th style={{ 'minWidth': '150px' }}>Sla Category</th>
                                                        <th style={{ 'minWidth': '250px' }}>Comapany</th>
                                                        <th style={{ 'minWidth': '200px' }}>Assign To User</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {results.map((option, index) => (
                                                        <tr key={option.SLAID} onClick={() => handleSearchChange([option])} style={{ cursor: 'pointer' }}>
                                                            <td><Highlighter search={searchText}>{option.SLAID}</Highlighter></td>
                                                            <td><Highlighter search={searchText}>{option.SLAType}</Highlighter></td>
                                                            <td><Highlighter search={searchText}>{option.SLACategoryName}</Highlighter></td>
                                                            <td><Highlighter search={searchText}>{option.CustomerName}</Highlighter></td>
                                                            <td><Highlighter search={searchText}>{option.AssignToUser}</Highlighter></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    );
                                }}
                            />
                            {/* <img src={searchIcon} alt="Search" onClick={handleSearchClick} /> */}
                        </div>
                    </Col>
                    <Col md={2} className='filters-col'>
                        <div className='calendar-container'>
                            <DatePicker
                                className="select from-date"
                                dateFormat="dd/MM/yyyy"
                                selectsStart
                                placeholderText='From'
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                maxDate={new Date()}
                                onChangeRaw={e => e.preventDefault()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                            />
                            <img src={calendar} alt="Calendar" />
                        </div>
                    </Col>
                    <Col md={2} className='filters-col'>
                        <div className='calendar-container'>
                            <DatePicker
                                className="select to-date"
                                dateFormat="dd/MM/yyyy"
                                selectsEnd
                                placeholderText='To'
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                minDate={new Date()}
                                onChangeRaw={e => e.preventDefault()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                            />
                            <img src={calendar} alt="Calendar" />
                        </div>
                    </Col>
                    <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                    {/* {signInDetails[0].SignInType === "SuperAdmin" && <SbAddBtn btnName="Add SLA" onClickEffect={() => { handleOpenModal("") }} />} */}
                    {/* {moduleData?.CanCreate === true && CompanyID === 25 && SignInType === "SuperAdmin" && <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />} */}
                    {moduleData?.CanCreate === true && (SignInType === "SuperAdmin" || PreviousSuperAdminSignInType === "SuperAdmin") && <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />}
                </Col>
            </Row>
            <div className='customermanagement-table-div'>
                {moduleData?.CanView === true ? (
                    <>
                        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                            <Table>
                                <SortableHead axis="x" onSortEnd={onReorderEnd}>
                                    {columnsOrder.map((columnId, index) => {
                                        const column = columns.find(col => col.id === columnId);
                                        if (!column) return null; // Skip if column doesn't exist

                                        // Only display columns that are in filteredColumns
                                        if (!filteredColumns.find(col => col.id === columnId)) {
                                            return null;
                                        }
                                        return (
                                            <SortableCell key={column.id} index={index} value={
                                                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', minWidth: column.minWidth }} className='table-header-div'>
                                                    {column.label}
                                                    {column.sortable !== false && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={(event) => handleRequestSort(event, column.id)}
                                                        >
                                                            <img src={SortIcon} alt="Sort" />
                                                        </IconButton>
                                                    )}
                                                </div>
                                            } />
                                        );
                                    })}
                                </SortableHead>
                                <TableBody>
                                    {
                                        loading ? (
                                            [...Array(rowsPerPage)].map((_, index) => (
                                                <TableRow key={index}>
                                                    {columns.map((column) => (
                                                        <TableCell key={column.id} align={column.align}>
                                                            <Skeleton height={40} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        ) : paginatedData.length === 0 ? (
                                            // Display "No Data Found" row if no data is present in the paginated data
                                            <TableRow>
                                                <TableCell colSpan={columns.length}>
                                                    <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            paginatedData.map((customer) => (
                                                <TableRow key={customer.id}>
                                                    {columnsOrder.map((columnId) => {
                                                        const column = columns.find((col) => col.id === columnId);
                                                        if (!column || !filteredColumns.find(col => col.id === columnId)) {
                                                            return null; // Skip if column doesn't exist or not selected
                                                        }
                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                align={column.align}
                                                                className={clickedCell.rowId === customer.slaNo && clickedCell.columnId === column.id ? 'clicked-value' : ''}
                                                                onMouseDown={() => setClickedCell({ rowId: customer.slaNo, columnId: column.id })}
                                                                onMouseUp={() => setClickedCell({ rowId: null, columnId: null })}
                                                                onMouseLeave={() => setClickedCell({ rowId: null, columnId: null })}
                                                            >
                                                                {column.id === 'action' ? (
                                                                    <SbActionDropdownButton
                                                                        options={[
                                                                            (CompanyID === 25 && SignInType === "SuperAdmin" && { type: 'Edit' }),
                                                                            { type: 'View' },
                                                                            { type: 'Download' }
                                                                        ]}
                                                                        openAddModal={() => { handleOpenModal(customer.SLAID) }}
                                                                        addBulkModel={() => { handleOpenAssignToModal(customer.SLAID) }}
                                                                        // signInType={signInDetails[0].SignInType}
                                                                        achievedPercentage={customer.AchievedPercentage}
                                                                        moduleData={moduleData}
                                                                    // addAttachmentModal={handleOpenAttachmentUploadModal}
                                                                    />
                                                                ) :
                                                                    // column.id === 'StartDate/EndDate' ? (
                                                                    //     // Format and display the StartDate and EndDate
                                                                    //     <>
                                                                    //         <span>
                                                                    //             {/* {moment(customer.StartDate).format(DateFormat)} /
                                                                    //             {moment(customer.EndDate).format(DateFormat)} */}
                                                                    //             {formatDate(customer.StartDate)} / {formatDate(customer.EndDate)}
                                                                    //         </span>
                                                                    //     </>
                                                                    // ) :
                                                                    (
                                                                        <span
                                                                            onClick={() => {
                                                                                setClickedCell({ rowId: customer.slaNo, columnId: column.id }); // Track clicked cell
                                                                                handleOpenValueFilterModal(); // Open modal
                                                                            }}
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            {/* {customer[column.id] || 'NA'} */}
                                                                            {/* {renderCellValue(customer, column)} */}
                                                                            {column.id === 'AssignToUser' && Array.isArray(customer.AssignToUser)
                                                                                ? [...new Set(customer.AssignToUser.map(user => user.UserName))].join(', ')
                                                                                : renderCellValue(customer, column)}
                                                                        </span>
                                                                    )}
                                                            </TableCell>
                                                        )
                                                    }
                                                    )}
                                                </TableRow>
                                            )))}
                                </TableBody>
                            </Table>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={() => setAnchorEl(null)}
                            >
                                <MenuItem onClick={() => handleSortOrderChange('asc')}>
                                    <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                                    Ascending to Descending
                                </MenuItem>
                                <MenuItem onClick={() => handleSortOrderChange('desc')}>
                                    <img src={descToAsc} alt="" />&nbsp;&nbsp;
                                    Descending to Ascending
                                </MenuItem>
                            </Menu>
                        </TableContainer>
                        {/* Use PaginationComponent */}
                        <PaginationComponent
                            totalItems={filteredData.length}
                            itemsPerPage={rowsPerPage}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleRowsPerPageChange}
                        />
                    </>
                ) : (
                    <div className='d-flex align-items-center justify-content-center p-3'>
                        <img src={noModuleAccess} alt="" />
                    </div>
                )}
                {/* Upload Attachment Modal */}
                <Modal
                    show={showAttachmentUploadModal}
                    onHide={handleCloseBulkUploadModal}
                    centered
                    size="lg"
                    onDrop={handleDrop}
                    onDragOver={(e) => e.preventDefault()}
                    className='add-customer-modal add-user-modal'
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Upload Attachments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="bulkFileInput">
                            <div
                                className="drag-and-drop-area"
                                // onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <div className='drag-drop-container'>
                                    {files.length > 0 ? (
                                        files.map((file, index) => (
                                            <div key={index} className="file-info">
                                                <span>{file.name}</span>&nbsp;&nbsp;
                                                <ProgressBar
                                                    now={progress[index] || 0}
                                                    label={`${progress[index] || 0}%`}
                                                    variant={progress[index] === 100 ? "success" : "danger"}
                                                />
                                                <div className='d-flex justify-content-between align-items-center pt-2'>
                                                    <p> ({(file.size / (1024 * 1024)).toFixed(2)} MB)</p>
                                                    <p style={{ color: progress[index] === 100 ? "green" : "red" }}>
                                                        {progress[index] === 100 ? "Completed" : "Loading..."}
                                                    </p>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className='drag-drop-div'>
                                            <p>Drag & Drop files(Supports only JPG,JPEG,PNG)</p>
                                        </div>
                                    )}
                                </div>
                                <div className='browse-btn-div'>
                                    <SBSaveUpdateBtn btnName="Browse Files" onClickEffect={() => fileInputRef.current.click()} />
                                    <input
                                        type="file"
                                        multiple
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                        accept=".jpg,.jpeg,.png"
                                    />
                                </div>
                            </div>
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseBulkUploadModal} />
                        <SBSaveUpdateBtn btnName="Upload Attachment" />
                    </Modal.Footer>
                </Modal>
                {isModalOpen && <AddSLA
                    open={isModalOpen}
                    handleClose={handleCloseModal}
                    singleAssignedToSlaData={singleAssignedToSlaData}
                    assignedToSlaDatas={assignedToSlaDatas}
                    slaId={slaId}
                    getModuleFieldsNames={getModuleFieldsNames}
                />}
                {/* {isModalOpen && (
                    signInDetails[0].SignInType === "User" ? (
                        <UpdateSlaModal
                            open={isModalOpen}
                            handleClose={handleCloseModal}
                            singleAssignedToSlaData={singleAssignedToSlaData}
                            assignedToSlaDatas={assignedToSlaDatas}
                            slaId={slaId}
                        />
                    ) : (
                        <AddSLA
                            open={isModalOpen}
                            handleClose={handleCloseModal}
                            singleAssignedToSlaData={singleAssignedToSlaData}
                            assignedToSlaDatas={assignedToSlaDatas}
                            slaId={slaId}
                        />
                    )
                )} */}
                {viewSlaAssignToModal && <ViewAssignedToSla
                    viewSlaAssignToModal={viewSlaAssignToModal}
                    handleCloseAssignToModal={handleCloseAssignToModal}
                    singleAssignedToSlaData={singleAssignedToSlaData}
                />}
                {
                    showColumnFilterModal && (
                        <AssignedToSlaColumnFilterModal
                            showColumnFilterModal={showColumnFilterModal}
                            handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                            selectedColumns={selectedColumns}
                            handleSaveColumns={handleColumnSelectionChange}
                        />
                    )
                }
                {
                    showValueFilterModal && (
                        <SlaAssignToValueFilterModal
                            showValueFilterModal={showValueFilterModal}
                            handleCloseValueFilterModal={handleCloseValueFilterModal}
                        />
                    )
                }
            </div>
        </>
    );
};

export default AssignToTable;
